import React from 'react';
import DetailsPortal from './DetailsPortal';
import './OrderDetailsPanel.css';

const GatewayDetailsPanel = ({ gateway, onClose }) => {
  if (!gateway) return null;

  const gatewayData = gateway;

  const formatValue = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return String(value);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    try {
      const date = new Date(timestamp * 1000);
      if (isNaN(date.getTime())) {
        const date2 = new Date(timestamp);
        if (isNaN(date2.getTime())) return String(timestamp);
        return formatCustomDate(date2);
      }
      return formatCustomDate(date);
    } catch {
      return String(timestamp);
    }
  };

  const formatCustomDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
  };

  const getStatus = () => {
    const raw = gatewayData.status || gatewayData.Status || gatewayData.STATUS || '-';
    const lower = String(raw).toLowerCase();
    return {
      status: lower,
      text: raw === '-' ? raw : String(raw).charAt(0).toUpperCase() + String(raw).slice(1).toLowerCase()
    };
  };

  const status = getStatus();
  const ref = gatewayData.ref || gatewayData.id || '-';
  const name = gatewayData.name || gatewayData.Name || gatewayData.NAME || '-';
  const gatewayId = gatewayData.id || gatewayData.Id || gatewayData.ID || '-';
  const currency = gatewayData.currency || gatewayData.Currency || gatewayData.CURRENCY || '-';
  const method = gatewayData.method || gatewayData.Method || gatewayData.METHOD || '-';
  const geo = gatewayData.geo || gatewayData.Geo || gatewayData.GEO || '-';
  const traderId = gatewayData.traderId || gatewayData.TraderId || gatewayData.TRADER_ID || '-';
  const created = formatDate(gatewayData.create_time || gatewayData.Created || gatewayData.created);

  return (
    <DetailsPortal>
    <div className="order-details-overlay" onClick={onClose}>
      <div className="order-details-panel" onClick={(e) => e.stopPropagation()}>
        <div className="order-details-header">
          <h2>Gateway Details</h2>
          <button type="button" className="close-button" onClick={onClose}>Close</button>
        </div>
        <div className="order-details-content">
          <div className="order-summary">
            <div className="summary-main">
              <span className="summary-label">Gateway</span>
              <span className="summary-primary">{formatValue(name)}</span>
              <span className="summary-secondary">{formatValue(gatewayId)}</span>
            </div>
            <div className="summary-chips">
              <span className={`status-badge status-${status.status}`}>{status.text}</span>
              <span className="summary-chip">Currency: {formatValue(currency)}</span>
              <span className="summary-chip">Method: {formatValue(method)}</span>
            </div>
          </div>

          <div className="detail-section">
            <h3>Details</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Ref</span>
                <span className="detail-value">{formatValue(ref)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Name</span>
                <span className="detail-value">{formatValue(name)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">ID</span>
                <span className="detail-value">{formatValue(gatewayId)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Currency</span>
                <span className="detail-value">{formatValue(currency)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Geo</span>
                <span className="detail-value">{formatValue(geo)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Method</span>
                <span className="detail-value">{formatValue(method)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Trader ID</span>
                <span className="detail-value">{formatValue(traderId)}</span>
              </div>
            </div>
          </div>

          <div className="detail-section">
            <h3>Timeline</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Created</span>
                <span className="detail-value">{created}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </DetailsPortal>
  );
};

export default GatewayDetailsPanel;
